import React from 'react';
import CashReceiptsReport from '../../billing/CashReceiptsReport';

const PaidTab = () => <CashReceiptsReport />;

export default PaidTab;
